/*
 * @Descripttion: 
 * @version: 
 * @Author: yanghui
 * @Date: 2021-10-20 15:14:37
 * @LastEditors: yanghui
 * @LastEditTime: 2021-11-17 18:01:14
 */
/**
 * Created by lk on 17/6/4.
 */
 import axios from "../../utils/axios";

 // 获取列表
 export function giftList(query) {
     return axios({
         url: "/hfIntegralGiftManage/getIntegralGiftList",
         method: "get",
         params: query
     });
 }

 // 礼品管理-修改上下架状态 
 export function updateShowStatusApi(query) {
  return axios({
      url: "/hfIntegralGiftManage/updateShowStatus",
      method: "put",
      params: query
  });
} 

// 礼品管理-删除礼品
export function delIntegralGifApi(query) {
  return axios({
      url: "/hfIntegralGiftManage/delIntegralGif",
      method: "delete",
      params: query
  });
} 

//礼品管理详情
export function getIntegralGiftDetailsApi(query) {
  return axios({
      url: "/hfIntegralGiftManage/getIntegralGiftDetails",
      method: "get",
      params: query
  });
} 

//礼品添加
export function addIntegralGiftApi(data) {
  return axios({
      url: "/hfIntegralGiftManage/addIntegralGift",
      method: "post",
      data: data
  });
} 

//礼品编辑
export function updateIntegralGiftApi(data) {
  return axios({
      url: "/hfIntegralGiftManage/updateIntegralGift",
      method: "put",
      data: data
  });
} 

 // 获取角色列表
 export function authAdminRoleList(query) {
     return axios({
         url: "/admin/roleList",
         method: "get",
         params: query
     });
 }
 
 // 保存
 export function authAdminSave(data, formName, method = "post") {
     let url = formName === "add" ? "/admin/save" : "/admin/edit";
     return axios({
         url: url,
         method: method,
         data: data
     });
 }
 
// 新删除
export function deleteNewApi(data) {
  return axios({
      url: "/hfIntegralGiftManage/delIntegralGif",
      method: "post",
      data: data
  });
}
